import { useAtom } from 'jotai';

import { avalableROKInApartments, showFilterOptionsAtom } from '../states/planner';

export const FilterButton = () => {
  const [availableROK] = useAtom(avalableROKInApartments);
  const [showFilterOptions, setShowFilterOptions] = useAtom(showFilterOptionsAtom);
  if (availableROK.filter(item => item > 0).length < 2) return <></>;

  return (
    <li className="ml-6 h-6">
      <button
        className="font-style-one ml-auto font-bold"
        data-tooltip-id="filterBox"
        onClick={() => setShowFilterOptions(!showFilterOptions)}
      >
        Filtrera
      </button>
    </li>
  );
};
